import { capitalizeFirstLetter } from "@utils/helperFunctions";

export const normalizeCasing = (string) =>
  ["crm", "psa"].includes(string)
    ? string.toUpperCase()
    : capitalizeFirstLetter(string);
